import { useSelector } from 'react-redux';

export function useIsShowSearchRange() {
    return useSelector(state => state.gridUI.showSearchRange);
}

export function useSearchRange() {
    return useSelector(state => state.gridUI.searchRange || {});
}
